import { lazy } from "react";

export const Project = lazy(() => import("./project/Project"))
export const SystemFlags = lazy(() => import("./systemflags/SystemFlags"))
export const Holidays = lazy(() => import("./holidays/Holidays"))
export const Biometrics = lazy(() => import("./biometrics/Biometrics"))
export const BiometricsTabs = lazy(() => import("./biometrics/biometricsTabs/BiometricsTabs"))
export const ActivityLog = lazy(() => import("./activityLog/ActivityLog"))

// store
export * from "./systemflags/store"
export * from "./project/store"
export * from "./project/store/ProjectSlice"
export { default as ProjectReducer } from "./project/store/ProjectSlice"
export * from "./systemflags/store/SystemFlagSlice"
export { default as SystemFlagReducer } from "./systemflags/store/SystemFlagSlice"
export * from "./holidays/store"
export * from "./holidays/store/HolidaySlice"
export { default as HolidayReducer } from "./holidays/store/HolidaySlice"
export * from "./biometrics/store"
export * from "./biometrics/store/biometricStore"
export { default as BiometricsReducer } from "./biometrics/store/biometricStore/BiometricSlice"